<template>
  <div class="container">
    <l-map
      class="map"
      :zoom="zoom"
      :center="mapCenter"
      :zoom-control="false"
      :scroll-wheel-zoom="false"
      :double-click-zoom="false"
      :touch-zoom="false"
      :dragging="false"
      :keyboard="false"
      :box-zoom="false"
      :tap="false"
      style="pointer-events: none; height: 97vh; width: 84vw; margin-left: -49px"
    >
      <l-tile-layer :url="tileUrl" :attribution="tileAttribution" />

      <MarkersPage :places="offices.offices" :markerIcon="IconLocation" />

      <l-marker
        v-if="currentLocation?.lat !== undefined && currentLocation?.lng !== undefined"
        :lat-lng="[currentLocation.lat, currentLocation.lng]"
        :icon="PinLocation"
      >
        <l-popup>User Location</l-popup>
      </l-marker>
    </l-map>
  </div>
</template>

<script>
import { defineComponent, ref, onMounted, computed } from 'vue'
import { LMap, LTileLayer, LMarker, LPopup } from '@vue-leaflet/vue-leaflet'
import 'leaflet/dist/leaflet.css'

import MarkersPage from '@/components/MarkersPage.vue'
import offices from '@/data/offices.json'
import { IconLocation } from '@/utils/IconLocation'
import { PinLocation } from '@/utils/pinLocation'

export default defineComponent({
  name: 'WorldMap',
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LPopup,
    MarkersPage,
  },
  setup() {
    const zoom = ref(2)

    const currentLocation = ref({
      lat: 40.416775,
      lng: -3.70379,
    })

    const tileUrl = 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'
    const tileAttribution =
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'

    const mapCenter = computed(() => {
      const { lat, lng } = currentLocation.value
      return typeof lat === 'number' && typeof lng === 'number' ? [lat, lng] : [0, 0]
    })

    onMounted(() => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            currentLocation.value = {
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            }
          },
          (error) => {
            console.warn('Geolocation error:', error)
          },
          { enableHighAccuracy: true }
        )
      }
    })

    return {
      zoom,
      currentLocation,
      mapCenter,
      tileUrl,
      tileAttribution,
      offices,
      IconLocation,
      PinLocation,
    }
  },
})
</script>

<style scoped>
.container {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
}

.map {
  width: 100%;
  height: 97vh;
  border-radius: 15px;
}

@media (max-width: 992px) {
  .map {
    height: 85vh;
    width: 100%;
    border-radius: 12px;
  }
}

@media (max-width: 768px) {
  .map {
    height: 100vw; 
    width: 100vw;
    border-radius: 10px;
  }
}

@media (max-width: 480px) {
  .map {
    height: 90vw; 
    width: 64vh;
    border-radius: 8px;
  }
}

</style>
